var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-idea-settings',{attrs:{"visible":_vm.dialogIdeaSettingsVisible,"category":_vm.$store.state.idea.catalogueCategory,"idea":_vm.$store.state.idea.catalogueIdea || {},"update-idea-settings":true},on:{"close-dialog":_vm.onCloseDialogIdeaSettings,"idea-saved":_vm.onCloseDialogIdeaSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }